export const JOB_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  FINISHED: 'finished',
  COMPLETED: 'completed',
  FAILED: 'failed',
}

export const JOB_STATUS_LABELS = {
  pending: 'status.pending',
  processing: 'status.processing', 
  finished: 'status.completed',
  completed: 'status.completed',
  failed: 'status.failed',
}

export const JOB_STATUS_COLORS = {
  pending: 'text-yellow-600 bg-yellow-50',
  processing: 'text-blue-600 bg-blue-50',
  finished: 'text-green-600 bg-green-50',
  completed: 'text-green-600 bg-green-50',
  failed: 'text-red-600 bg-red-50',
}

export const SUPPORTED_LANGUAGES = [
  { code: 'sq-AL', nameKey: 'lang.sq-AL', flag: '🇦🇱' },
  { code: 'bs-BA', nameKey: 'lang.bs-BA', flag: '🇧🇦' },
  { code: 'bg-BG', nameKey: 'lang.bg-BG', flag: '🇧🇬' },
  { code: 'hr-HR', nameKey: 'lang.hr-HR', flag: '🇭🇷' },
  { code: 'cs-CZ', nameKey: 'lang.cs-CZ', flag: '🇨🇿' },
  { code: 'da-DK', nameKey: 'lang.da-DK', flag: '🇩🇰' },
  { code: 'nl-NL', nameKey: 'lang.nl-NL', flag: '🇳🇱' },
  { code: 'en-GB', nameKey: 'lang.en-GB', flag: '🇬🇧' },
  { code: 'en-US', nameKey: 'lang.en-US', flag: '🇺🇸' },
  { code: 'et-EE', nameKey: 'lang.et-EE', flag: '🇪🇪' },
  { code: 'fi-FI', nameKey: 'lang.fi-FI', flag: '🇫🇮' },
  { code: 'fr-FR', nameKey: 'lang.fr-FR', flag: '🇫🇷' },
  { code: 'de-DE', nameKey: 'lang.de-DE', flag: '🇩🇪' },
  { code: 'el-GR', nameKey: 'lang.el-GR', flag: '🇬🇷' },
  { code: 'hu-HU', nameKey: 'lang.hu-HU', flag: '🇭🇺' },
  { code: 'is-IS', nameKey: 'lang.is-IS', flag: '🇮🇸' },
  { code: 'it-IT', nameKey: 'lang.it-IT', flag: '🇮🇹' },
  { code: 'lv-LV', nameKey: 'lang.lv-LV', flag: '🇱🇻' },
  { code: 'lt-LT', nameKey: 'lang.lt-LT', flag: '🇱🇹' },
  { code: 'mk-MK', nameKey: 'lang.mk-MK', flag: '🇲🇰' },
  { code: 'no-NO', nameKey: 'lang.no-NO', flag: '🇳🇴' },
  { code: 'pl-PL', nameKey: 'lang.pl-PL', flag: '🇵🇱' },
  { code: 'pt-PT', nameKey: 'lang.pt-PT', flag: '🇵🇹' },
  { code: 'ro-RO', nameKey: 'lang.ro-RO', flag: '🇷🇴' },
  { code: 'ru-RU', nameKey: 'lang.ru-RU', flag: '🇷🇺' },
  { code: 'sk-SK', nameKey: 'lang.sk-SK', flag: '🇸🇰' },
  { code: 'sl-SI', nameKey: 'lang.sl-SI', flag: '🇸🇮' },
  { code: 'es-ES', nameKey: 'lang.es-ES', flag: '🇪🇸' },
  { code: 'sv-SE', nameKey: 'lang.sv-SE', flag: '🇸🇪' },
  { code: 'uk-UA', nameKey: 'lang.uk-UA', flag: '🇺🇦' },
]

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

export const SUPPORTED_FILE_TYPES = [
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/json',
  'application/xml',
  'text/xml',
]

export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB

export const SUPPORTED_DOMAINS = [
  { code: 'general', icon: '📄' },
  { code: 'technical', icon: '⚙️' },
  { code: 'conversational', icon: '💬' },
  { code: 'legal', icon: '⚖️' },
  { code: 'medical', icon: '🏥' },
  { code: 'ecommerce', icon: '🛒' },
  { code: 'financial', icon: '💰' },
  { code: 'marketing', icon: '📢' }
]

export const DEFAULT_DOMAIN = 'general'

// Context settings  
export const DEFAULT_CONTEXT_KEY = 'translation.defaultContext'
export const MAX_CONTEXT_LENGTH = 500